/** Granular admin help topics — BT-028-R1 (EN). */

export const helpTopicsAdminEn028R1 = {
  "public-home": {
    key: "public-home",
    screenLabel: "Public home",
    purpose: "Discover Phase 1 Shotokan AAMC Black Dragon portal and demo scope.",
    actions: [
      "Browse dojos, instructors and public documents.",
      "Spot [DEMO] banner and slots awaiting client file.",
      "Request an account or log in with demo accounts.",
    ],
    warning: "[DEMO] data — 10 official dojos awaiting client file.",
    nextStep: "Explore dojos or log in as Hanshi for admin.",
  },
  login: {
    key: "login",
    screenLabel: "Sign in",
    purpose: "Access a space by demo role (admin, sensei, sempai, parent, student).",
    actions: [
      "Use demo username/password (listed on screen).",
      "Example: admin/demo, sensei/demo, etudiant/demo.",
      "Switch FR/EN before login if needed.",
    ],
    warning: "Local Phase 1 accounts only — not production.",
    nextStep: "After login, use your role menu or tabs.",
  },
  "account-request": {
    key: "account-request",
    screenLabel: "Account request",
    purpose: "Request form — local demo storage, no automatic approval.",
    actions: ["Fill identity and desired role.", "Submit — local Phase 1 storage."],
    warning: "[DEMO] — no real automatic account creation.",
    nextStep: "Use a demo account to test immediately.",
  },
  "admin-dashboard": {
    key: "admin-dashboard",
    screenLabel: "Admin dashboard",
    purpose: "Hanshi overview: organisation, activities, progression and Shotokan.",
    actions: [
      "Use 6 collapsible sidebar groups.",
      "Shotokan Black Dragon for titles and Documents & Evidence.",
      "CSV import or controlled document import as needed.",
    ],
    checklist: ["Documents & Evidence is not a main link — only inside Shotokan."],
    warning: "Phase 1 — no payments or operational attendance. [DEMO] data.",
    nextStep: "Open Instructor management or Shotokan as needed.",
  },
  "admin-instructors": {
    key: "admin-instructors",
    screenLabel: "Instructor management",
    purpose: "Manage Sensei, Sempai and leadership — demo or received data, dojo links to confirm.",
    actions: [
      "Search, sort and filter by status.",
      "Add or edit an instructor (demo).",
      "Spot [DEMO] badges and « To confirm » statuses.",
    ],
    checklist: ["Verify dojo association before any client presentation."],
    warning: "Leadership received, to confirm — no external recognition shown as official.",
    nextStep: "Link Sensei ↔ dojo when client file returns.",
  },
  "admin-dojos": {
    key: "admin-dojos",
    screenLabel: "Dojo management",
    purpose: "Manage dojo locations, cities and Sensei assignments.",
    actions: ["Search and filter dojos.", "Add or edit a demo location.", "Assign a responsible Sensei."],
    warning: "[DEMO] slots — client file pending.",
    nextStep: "Check Instructor management for Sensei ↔ dojo links.",
  },
  "admin-students": {
    key: "admin-students",
    screenLabel: "Student management",
    purpose: "Student lists per dojo — minimal initial dataset BT-046 (Marcel Charette, Natalie Lavigne); bulk import later.",
    actions: ["Search by name or group.", "Filter by status.", "Add or edit a record."],
    warning: "Belts and groups marked to confirm — only the [DEMO] child tests the Parent space.",
    nextStep: "CSV or client file import after Hanshi validation.",
  },
  "admin-assistants": {
    key: "admin-assistants",
    screenLabel: "Assistants / Sempai",
    purpose: "Manage Sempai assistants — limited Phase 1 role.",
    actions: ["Browse assistant list.", "Filter by dojo or status.", "Add a demo record if needed."],
    warning: "[DEMO] — Sempai cannot validate a grade or assign a title.",
    nextStep: "Check assisted classes in Sempai space.",
  },
  "admin-parents": {
    key: "admin-parents",
    screenLabel: "Parent management",
    purpose: "Parent ↔ child links — Phase 1 demo data.",
    actions: ["Search a parent.", "Review linked children.", "Filter by status."],
    warning: "Payments not managed in Phase 1. [DEMO].",
    nextStep: "Check Parent space for link consistency.",
  },
  "admin-shotokan": {
    key: "admin-shotokan",
    screenLabel: "Shotokan Black Dragon",
    purpose: "Titles, recognitions, authority module and integrated Documents & Evidence.",
    actions: [
      "Browse overview and sub-menus.",
      "Titles and applications — internal referential.",
      "Documents & Evidence via sub-menu (admin).",
    ],
    warning: "Internal referential — validate per authority documents provided. [DEMO].",
    nextStep: "Check required documents before any decision.",
  },
  "admin-documents-preuves": {
    key: "admin-documents-preuves",
    screenLabel: "Documents & Evidence",
    purpose: "Manage proofs, folders and journal — integrated in Shotokan (admin).",
    actions: ["Browse documents, folders, journal.", "Controlled import if needed."],
    warning: "No automatic official validation — initial status received — validation required.",
    nextStep: "Controlled import to add a client file.",
  },
  "admin-documents-preuves-import": {
    key: "admin-documents-preuves-import",
    screenLabel: "Controlled import",
    purpose: "Import client document metadata without Phase 1 server storage.",
    actions: ["Enter file name.", "Preview before import.", "Confirm — received — validation required enforced."],
    warning: "File not officially stored — secure backend Phase 2+.",
    nextStep: "Check journal after import.",
  },
  "admin-import": {
    key: "admin-import",
    screenLabel: "CSV import",
    purpose: "Load dojos, Sensei and students from CSV. Official BT-037 model is documented in demo loop — real Excel import after client file.",
    actions: [
      "Read official BT-037 model panel (expected sections, reception checklist).",
      "Paste compliant CSV for legacy import.",
      "Preview then confirm — recommended: official + keep [DEMO].",
    ],
    warning: "No automatic BT-037 Excel import in Phase 1 — no real data.",
    nextStep: "Check Hanshi dashboard after demo CSV import.",
  },
  "admin-presentation-interactive": {
    key: "admin-presentation-interactive",
    screenLabel: "Interactive presentation",
    purpose: "Guide a client demo, capture step notes and generate an improvement report — separate from Training and Help.",
    actions: [
      "Choose express (25 min) or full (50–65 min).",
      "Follow the 7 BT-033 blocks and open real screens.",
      "Add notes, questions or voice dictation when available.",
      "Generate and export the improvement report.",
    ],
    warning: "[DEMO] — do not present demo data as real. No server storage.",
    nextStep: "Mark completed steps then export the report after the meeting.",
  },
  "admin-documents": {
    key: "admin-documents",
    screenLabel: "Document management",
    purpose: "Classify documents by visibility — Hanshi validation required.",
    actions: ["Search a document.", "Classify visibility and status.", "Do not publish sensitive protocols without validation."],
    warning: "Do not automatically publish Black Dragon / ritual protocols.",
    nextStep: "Shotokan → Documents & Evidence for proofs.",
  },
  "admin-organisation": {
    key: "admin-organisation",
    screenLabel: "Organisation",
    purpose: "Shotokan AAMC Black Dragon structure — dojo and headcount summary.",
    actions: ["Review organisation summary.", "Check demo counters."],
    warning: "[DEMO] data — official structure awaiting client.",
    nextStep: "Dojo management for locations.",
  },
  "sensei-dashboard": {
    key: "sensei-dashboard",
    screenLabel: "Sensei space",
    purpose: "Manage dojo, classes, students, progress and Shotokan (limited rights).",
    actions: [
      "Grouped navigation: My dojo, My classes, My students, Progress.",
      "Shotokan Black Dragon for titles and required documents.",
      "Useful documents for dojo sharing.",
    ],
    warning: "[DEMO] — no official title assignment without authority. No full admin.",
    nextStep: "Open My classes or My students as needed.",
  },
  "sempai-dashboard": {
    key: "sempai-dashboard",
    screenLabel: "Sempai space",
    purpose: "Assist classes and browse students — consultation only.",
    actions: [
      "Assisted classes, light attendance, progress consultation.",
      "Shotokan read-only — required documents.",
    ],
    warning: "[DEMO] — Sempai cannot validate a grade or assign a title.",
    nextStep: "Browse your assisted classes.",
  },
  "student-dashboard": {
    key: "student-dashboard",
    screenLabel: "My student space",
    purpose: "Overview: dojo, Sensei, quick access to tabs.",
    actions: ["My classes, events, progress, titles, documents.", "7 simple tabs at top."],
    warning: "[DEMO] — no confidential documents or admin.",
    nextStep: "Open My classes or My progress.",
  },
  "parent-dashboard": {
    key: "parent-dashboard",
    screenLabel: "Parent space",
    purpose: "Follow your children: schedules, events, progress, authorized documents.",
    actions: ["7 tabs: My children, Schedule, Events, etc.", "Review child profiles."],
    warning: "Payments not managed in Phase 1. [DEMO]. No full Shotokan access.",
    nextStep: "Schedule or Progress as needed.",
  },
};

export const helpFallbackEn028R1 = {
  key: "__fallback__",
  screenLabel: "Unlisted page",
  purpose: "Generic help — this route does not yet have a dedicated topic.",
  actions: ["Use the main menu.", "Contact administrator if the issue persists."],
  warning: "[DEMO] — technical fallback, must not appear on main Phase 1 routes.",
  nextStep: "Return to home or your role dashboard.",
};
